export default "__VITE_ASSET__DtlFrm4K__"